import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PrintCompletionDialog from './PrintCompletionDialog';
import { completeAsBundle } from '../../../reducers/requests';
import {
  cancelSelectionForBundlingPatients,
  fetchSpecificPatientsOnly
} from '../../../reducers/patients';
import { COMMON_PATIENT_INCLUDES } from '../../../constants/queries';
import {
  closeGlobalBackdropAction,
  openGlobalBackdropAction
} from '../../../reducers/globalBackdrop';

const patientIncludes = [
  ...COMMON_PATIENT_INCLUDES,
  'customer_request.printing_request.bundled_shipment.shipping_cost',
  'bundled_shipment.shipping_cost',
  'rx_form.shipping_location'
];

const BundleCompletionDialog = ({
  patients,
  submit,
  close,
  reloadPatients,
  openBackDrop,
  closeBackdrop
}) => {
  const [submittedValues, setSubmittedValues] = useState(null);

  const handleClose = () => {
    setSubmittedValues(null);
    close();
  };

  const handleContinue = ({
    tracking_number: trackingNumber,
    custom_shipping_fee: customShippingFee,
    internal_shipping_cost: internalShippingCost
  }) => {
    openBackDrop();
    setSubmittedValues({
      tracking_number: trackingNumber,
      custom_shipping_fee: customShippingFee,
      internal_shipping_cost: internalShippingCost
    });
    submit(patients, trackingNumber, customShippingFee, internalShippingCost)
      .then(() => {
        setSubmittedValues(null);
        close();
      })
      .catch(() => {})
      .finally(() => {
        closeBackdrop();
        reloadPatients(patients);
      });
  };

  return (
    <PrintCompletionDialog
      open={patients !== null}
      onClose={handleClose}
      onContinue={handleContinue}
      title="Bundled Shipping"
      initialValues={submittedValues || {}}
    />
  );
};

BundleCompletionDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patients: PropTypes.array,
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  reloadPatients: PropTypes.func.isRequired,
  openBackDrop: PropTypes.func.isRequired,
  closeBackdrop: PropTypes.func.isRequired
};

BundleCompletionDialog.defaultProps = {
  patients: null
};

export default connect(
  state => ({
    patients: state.patients.selection.bundleShipment
  }),
  dispatch => ({
    submit: (patients, trackingNumber, customShippingFee, internalShippingCost) =>
      dispatch(
        completeAsBundle(
          patients.map(patient => patient.id),
          trackingNumber,
          customShippingFee,
          internalShippingCost
        )
      ),
    reloadPatients: patients =>
      dispatch(
        fetchSpecificPatientsOnly(
          patients.map(patient => patient.id),
          patientIncludes
        )
      ),
    close: () => {
      dispatch(cancelSelectionForBundlingPatients());
    },
    openBackDrop: () => dispatch(openGlobalBackdropAction()),
    closeBackdrop: () => dispatch(closeGlobalBackdropAction())
  })
)(BundleCompletionDialog);
